import React, { useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from 'components/Login/Login';
import Session from 'components/Session/Session';
import Celebrity from 'components/Celebrity/Celebrity';
import Streamer from 'components/Streamer/Streamer';
import SubscriberPage from 'components/Subscriber/SubscriberPage';
import AdminPage from '../components/Admin/AdminPage';

const sessionStream = 'https://dev-stand.ru/media/cooking/onet/video.m3u8';
const AppRouter = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [userId, setUserId] = useState('');

  function handleDone({ userId }) {
    setLoggedIn(true);
    setUserId(userId);
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={loggedIn ? <Session userId={userId} /> : <Login onDone={handleDone} />} />
        <Route path="/streamer" element={<Streamer cdnPreviewTemplate="facesOnlyHD" />} />
        <Route path="/celebrity" element={<Celebrity cdnPreviewTemplate="facesOnly" />} />
        <Route path="/celebrity-merged" element={<Celebrity cdnPreviewTemplate="withMainVideo" />} />
        <Route path="/sportian-celebrity" element={<Celebrity cdnPreviewTemplate="facesOnly" />} />
        <Route
          path="/onet-celebrity"
          element={<Celebrity cdnPreviewTemplate="facesOnly" sessionStream={sessionStream} isControlled={true} />}
        />
        <Route
          path="/subscriber"
          element={loggedIn ? <SubscriberPage userId={userId} /> : <Login onDone={handleDone} />}
        />
        <Route path="/admin" element={loggedIn ? <AdminPage userId={userId} /> : <Login onDone={handleDone} />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
